module.exports = __webpack_public_path__ + "static/img/36c1439e9934b8475e5e641c2dd2e56b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_05.png
// module id = JYii
// module chunks = 1